import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ContratoSelecionarFormaPagamentoModule, FooterModule, HeaderModule, InputModule, SelectModule } from '@usucampeao/ui-mobile';
import { PipesModule } from '@usucampeao/utils-frontend';
import { DetalhesSuperSocialModule } from 'libs/ui-mobile/src/lib/pages/cadastros-novo/detalhes-super-social/detalhes-super-social.module';
import { NgxMaskModule } from 'ngx-mask';
import { MoradoresComRendaFormPageRoutingModule } from './moradores-com-renda-form-routing.module';
import { MoradoresComRendaFormPage } from './moradores-com-renda-form.page';

@NgModule({
  declarations: [
    MoradoresComRendaFormPage,
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    // route
    MoradoresComRendaFormPageRoutingModule,
    // components
    ContratoSelecionarFormaPagamentoModule,
    DetalhesSuperSocialModule,
    HeaderModule,
    InputModule,
    SelectModule,
    FooterModule,
    // Pipes
    PipesModule,
    // external
    NgxMaskModule.forRoot()
  ]
})
export class MoradoresComRendaFormPageModule { }
